import { CHILLNN_ROOM_RANK_PLAN_ID, ROOM_RATE_PLAN_ID } from "./constants";

import type { RateMatrixPriceSource } from "./types";

/**
 * GraphQL に priceSource は無い。行の planID / isSCConnected から表示ラベル用に推論する。
 * 部屋料金無料は API に出ないので chillnn_plan に寄せる。
 */
export const inferPriceSource = (row: {
	planID: string;
	isSCConnected: boolean;
}): RateMatrixPriceSource => {
	if (row.planID === CHILLNN_ROOM_RANK_PLAN_ID) {
		return "chillnn_room_rank";
	}
	if (row.planID === ROOM_RATE_PLAN_ID) {
		return "sc_daily_rate_room";
	}
	if (row.isSCConnected) {
		return "sc_daily_rate_plan_room";
	}
	return "chillnn_plan";
};
